export const HAND_FINGER_OPTIONS = [
    { value: 'thumb', label: 'thumb' },
    { value: 'index', label: 'index finger' },
    { value: 'middle', label: 'middle finger' },
    { value: 'ring', label: 'ring finger' },
    { value: 'pinky', label: 'pinky' },
];

export const DEFAULT_FINGER = 'thumb';

const FINGER_TIP_INDEX = {
    thumb: 4,
    index: 8,
    middle: 12,
    ring: 16,
    pinky: 20,
};

export function normalizeFinger(value) {
    const key = value?.toLowerCase?.() || DEFAULT_FINGER;
    const normalized = HAND_FINGER_OPTIONS.find(opt => opt.value === key || opt.label === key);
    return normalized ? normalized.value : DEFAULT_FINGER;
}

export function getHandLandmarkIndex(finger = DEFAULT_FINGER) {
    const fingerKey = normalizeFinger(finger);
    return FINGER_TIP_INDEX[fingerKey] ?? FINGER_TIP_INDEX[DEFAULT_FINGER];
}
